import { useNavigate } from "react-router";
import "./Hero.css";

export default function Hero() {
    const navigate = useNavigate();

    const handleCustomOrdersClick = () => {
        navigate("/contact");
    }

    const handleShopClick = () => {
        navigate("/shop");
    }

    return (
        <section className="hero">
            <div className="heroText">
                <p id="tag">
                    3D Prints for Gamers and Collectors
                </p>
                <h2>Epic 3D Prints for Your Next Adventure</h2>
                <p>
                    Shop premium dice boxes/towers, dungeon terrain, prop weapons, and custom fantasy accessories for tabletop RPGs, cosplay, and collectors.
                </p>
                {/* <div className="button-container">
                    <button>Shop Best Sellers</button>
                    <button>Browse Categories</button>
                </div> */}
            </div>
            <div className="tiles">
                <div className="tile" onClick={handleShopClick}>
                    Checkout the Shop
                </div>
                {/* <div className="tile">
                    Dungeon Tiles
                </div>
                <div className="tile">
                    Prop Weapons
                </div> */}
                <div className="tile" onClick={handleCustomOrdersClick}>
                    Custom Orders
                </div>
            </div>
        </section>
    )
}